import React, { useEffect, useState } from 'react'
import Flex from 'typescript-styled-flex'
import { useTranslation } from 'react-i18next'
import Modal from '../../components/Template/Modal'
import PremiumStart from '../../assets/premium/premium_start.png'
import styled from '../../theme'
import Button from '../../components/Template/Button'
import { is } from '../../components/MediaQuery'

const Header = styled.div`
  font-weight: bold;
  font-size: 18px;
`

function NewVersionModal({ open, version, reloadApp }) {
  const { t } = useTranslation()
  const isDesktop = is.desktop()
  const [ref, setRef] = useState(null as HTMLSpanElement)

  useEffect(() => {
    if (ref) {
      const element = Array.from(ref.children).find(
        (child) => child.tagName === 'A',
      )
      if (element) {
        element.setAttribute('target', '_blank')
      }
    }
  })

  return (
    <Modal
      style={{
        borderRadius: '11px',
        margin: '0 10px',
        maxWidth: '804px',
        padding: 0,
        transform: `translateY(${isDesktop ? '-20vh' : 0})`,
        width: isDesktop ? '804px' : 'unset',
      }}
      onClose={null}
      open={open}
    >
      <Flex full={true} row={isDesktop} columnReverse={!isDesktop}>
        <img
          alt={'new version'}
          style={{
            borderRadius: isDesktop ? '10px 0 0 10px' : 'unset',
            height: '250px',
            maxWidth: isDesktop ? '396px' : '410px',
            width: 'auto',
          }}
          src={PremiumStart}
        />
        <Flex
          full={true}
          justifyBetween={true}
          alignCenter={true}
          style={{ maxWidth: '410px', minHeight: '250px', padding: '1.5em' }}
          column={true}
        >
          <Header>
            {t('application_block_dialog_title')} v {version}
          </Header>
          <span
            ref={setRef}
            style={{
              fontSize: '16px',
              lineHeight: '1.4',
              padding: '0 20px',
              textAlign: 'center',
            }}
            dangerouslySetInnerHTML={{
              __html:
                t('BBO_1360_update_info') === 'BBO_1360_update_info'
                  ? 'Aplikacja wymaga aktualizacji. </br> Wiecej informacji o nowej wersji znajdziesz <a class="btn-update-href">tutaj</a>.'
                  : t('BBO_1360_update_info'),
            }}
          />
          <Button onClick={reloadApp} style={{ width: '100%' }} primary={true}>
            {t('application_block_dialog_update_btn')}
          </Button>
        </Flex>
      </Flex>
    </Modal>
  )
}

export default NewVersionModal
